import { FormInstance } from 'antd';
import { calculateLoanClosingCostAmount } from './calculateLoanClosingCostAmount';
import { EnumClosingCostType } from '../types/settings';
import { formatAmount } from './formatAmount';
import { ILoanClosingCost, ISettingItem } from '../hooks/users';

type FieldValues = {
  uip?: number;
  vaFundingFee?: number;
  loanPoints?: number;
}

export const calculateClosingCosts = (
  form: FormInstance,
  loanIndex: string | number,
  loansClosingCosts?: ILoanClosingCost[],
  reportClosingCosts?: ISettingItem[],
  {
    uip,
    vaFundingFee,
    loanPoints
  }: FieldValues = {}
) => {
  const uipActive = form.getFieldValue(['tableView', 'uip', 'active']);
  const vaFundingFeeActive = form.getFieldValue(['tableView', 'vaFundingFee', 'active']);
  const loanPointsActive = form.getFieldValue(['tableView', 'loanPoints', 'active']);
  const loan = form.getFieldValue(['loans', loanIndex]);
  const addUip = form.getFieldValue(['loans', loanIndex, 'addUip']);
  const addVaFundingFee = form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addVaFundingFee']);
  const closingCostsClearedAt = form.getFieldValue(['loans', loanIndex, 'externalLoan', 'closingCostsClearedAt'])

  if (closingCostsClearedAt) return 0;

  const loanClosingCosts = loansClosingCosts?.filter(cost => cost.loanId === loan.id);

  const totalClosingCosts = loanClosingCosts?.reduce((total, closingCost) => {
    const reportClosingCost = reportClosingCosts?.find(c => c.name === closingCost.name);

    if (closingCost.name === 'uip' && uipActive && !addUip) {
      return total + (uip ?? closingCost.amount)
    }

    if (closingCost.name === 'vaFundingFee' && vaFundingFeeActive && !addVaFundingFee) {
      return total + (vaFundingFee ?? closingCost.amount)
    }

    if (closingCost.name === 'loan_points' && loanPointsActive) {
      return total + (loanPoints ?? closingCost.amount)
    }

    if (reportClosingCost?.active) {
      const closingCostAmount = closingCost.type === EnumClosingCostType.flatFee ?
        closingCost.amount : reportClosingCost?.amount;

      const amount = calculateLoanClosingCostAmount(
        loan,
        closingCost.type,
        closingCostAmount ?? 0,
        closingCost.propertyTaxesMonthsCollected,
        closingCost.daysCollected
      )

      return total + amount;
    }

    return parseFloat(formatAmount(total)) || 0;
  }, 0) ?? 0;

  return parseFloat(formatAmount(totalClosingCosts));
}
